"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sliderStyleHookMapping = void 0;
const sliderStyleHookMapping = exports.sliderStyleHookMapping = {
  activeThumbIndex: () => null,
  max: () => null,
  min: () => null,
  minStepsBetweenValues: () => null,
  step: () => null,
  values: () => null
};